import * as React from 'react';
import { GridLayout, SelectableCard } from '@salecycle/ui-component-library';
import { Objective, Objectives } from 'entities/campaign/objectives';
import { Features } from 'entities/campaign';
import { useNewCampaignDispatch, useNewCampaignState } from '../../../context/UseNewCampaignContext';
import { updateStepValidityAction } from '../../../actions';
import { useFlags } from 'core/app/AppContext';
import { useTranslation } from 'react-i18next';

export interface ObjectivesObject {
  objectiveKey: Objective;
  hasLiveFeatures: boolean;
}

interface IStateProps {
  currentStep?: number;
}

/* eslint-disable react-hooks/exhaustive-deps */
export const ObjectivesStep: React.FC<IStateProps> = ({ currentStep }: IStateProps) => {
  const { t } = useTranslation('campaigns');
  const dispatch = useNewCampaignDispatch();
  const { hasFlag } = useFlags();

  const { validSteps, combinedCampaign } = useNewCampaignState();

  const hasLiveFeatures = (obj: Objective) => {
    const featuresLive = Features.getFeaturesForObjective(obj).some(feat => {
      const featureFlag = Features.getFeatureFlag(feat);
      return !!featureFlag ? hasFlag(featureFlag) : true;
    });
    return featuresLive;
  };

  const objectives: ObjectivesObject[] = Objectives.getMPSObjectives().map(obj => ({
    objectiveKey: obj,
    hasLiveFeatures: hasLiveFeatures(obj),
  }));

  const handleObjectiveSelect = (objective: Objective) => () => {
    dispatch({
      type: 'SET_SELECTED_OBJECTIVE_VALUE',
      payload: { selectedObjective: objective },
    });
  };

  React.useEffect(() => {
    updateStepValidityAction(!!combinedCampaign.objective, validSteps, currentStep, dispatch);
  }, [combinedCampaign.objective]);

  return (
    <GridLayout
      heading={t('newCampaigns.objectives.heading')}
      childWidth={250}
      showSidebar={true}
      sidebarHeading={t('newCampaigns.sidebar.heading')}
    >
      {objectives.map(
        obj =>
          obj.hasLiveFeatures && (
            <SelectableCard
              key={`select-objective-${obj.objectiveKey}`}
              heading={t(Objectives.getTitle(obj.objectiveKey))}
              icon={Objectives.getIcon(obj.objectiveKey)}
              description={t(Objectives.getDescription(obj.objectiveKey))}
              onClick={handleObjectiveSelect(obj.objectiveKey)}
              isSelected={obj.objectiveKey === combinedCampaign.objective}
            />
          ),
      )}
    </GridLayout>
  );
};
